import { useQuery } from '@tanstack/react-query'
import { queryClient } from '../App'
import { getServiceReceivers } from '../services/ApiService'

export const useGetReceiverModels = () => {
  return useQuery(
    {
      queryKey: ['get-service-recivers'],
      queryFn: () => getServiceReceivers(),
      placeholderData: [],
      staleTime: 1000000,
    },
    queryClient,
  )
}
